module.exports = __webpack_public_path__ + "static/media/1.eff3baf8.jpg";